/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import pdfMake from 'pdfmake/build/pdfmake.js';
import {
  CanvasElement,
  Content,
  ContentColumns,
  ContentTable,
  ContentText,
  TDocumentDefinitions,
} from 'pdfmake/interfaces';
// import LatoBold from '../../../../assets/fonts/lato/Lato-Bold.ttf';
// import LatoBoldItalic from '../../../../assets/fonts/lato/Lato-BoldItalic.ttf';
// import LatoItalic from '../../../../assets/fonts/lato/Lato-Italic.ttf';
// import LatoRegular from '../../../../assets/fonts/lato/Lato-Regular.ttf';
import bgLogoKF from '../../../../assets/images/export-header-bg.png';
import '../../../../assets/vfs_fonts_lato.js';
import { JobPricingReportConstants } from '../../../../constants/JobPricingReportConstants';
import {
  BehavioralCompetenciesData,
  SkillsData,
  SuccessProfileDetails,
} from '../../../../helpers/models/JobPricingDetailModels';
import { getDataUrlForImageUrl } from '../../../../utilities/image.utils';

const PURPLE_LINE_COLOR = '#7638EB';
const GREEN_BG_COLOR = '#008369';
const PRIMARY_TEXT_COLOR = '#243D42';
const TEXT_WHITE_COLOR = '#FFFFFF';
const TABLE_BORDER_COLOR = '#D9D8D8';
const TABLE_BG_COLOR = '#FAF9F9';
const LINE_COLOR = '#A0AFB2';
const VERTICAL_LINE_COLOR = '#8F918D';

pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf',
  },
  Lato: {
    normal: 'Lato-Regular.ttf',
    bold: 'Lato-Bold.ttf',
    italics: 'Lato-Italic.ttf',
    bolditalics: 'Lato-BoldItalic.ttf',
  },
};

pdfMake.tableLayouts = {
  insightsTableLayout: {
    vLineWidth: function (i) {
      return 0.5;
    },
    hLineWidth: function (i) {
      return 0.5;
    },
  },
  reportTableLayout: {
    hLineWidth: function (i, node) {
      return 1;
    },
    vLineWidth: function (i, node) {
      return i === 0 || i === node.table.widths?.length ? 0 : 1;
    },
    hLineColor: function (i, node) {
      return TABLE_BORDER_COLOR;
    },
    vLineColor: function (i, node) {
      return TABLE_BORDER_COLOR;
    },
    paddingTop: function (i, node) {
      return 8;
    },
    paddingBottom: function (i, node) {
      return 8;
    },
  },
  successProfileTableLayout: {
    hLineWidth: function (i, node) {
      return i === 0 || i === node.table.body.length ? 0.5 : 0;
    },
    vLineWidth: function (i, node) {
      return i === 0 || i === node.table.widths?.length ? 0.5 : 0;
    },
    hLineColor: function (i, node) {
      return PURPLE_LINE_COLOR;
    },
    vLineColor: function (i, node) {
      return PURPLE_LINE_COLOR;
    },
    paddingLeft: function (i, node) {
      return 8;
    },
    paddingRight: function (i, node) {
      return 8;
    },
  },
  footerTableLayout: {
    hLineWidth: function (i, node) {
      return 0;
    },
    vLineWidth: function (i, node) {
      return 0;
    },
    paddingLeft: function (i, node) {
      return 6;
    },
    paddingRight: function (i, node) {
      return 6;
    },
    paddingTop: function (i, node) {
      return 6;
    },
    paddingBottom: function (i, node) {
      return 6;
    },
  },
};

const getSolidLineContent = () => {
  return {
    canvas: [
      {
        type: 'line',
        x1: 0,
        y1: 0,
        x2: 530,
        y2: 0,
        lineWidth: 0.5,
        lineColor: LINE_COLOR,
      },
    ],
    marginBottom: 12,
  } as Content;
};

const getDashLineContent = () => {
  return {
    canvas: [
      {
        type: 'line',
        x1: 0,
        y1: 0,
        x2: 530,
        y2: 0,
        lineWidth: 1,
        lineColor: LINE_COLOR,
        dash: {
          length: 1,
        },
      },
    ],
    marginBottom: 18,
  } as Content;
};

const getHeaderContent = (content: any[]) => {
  let header = {} as ContentText;
  content
    .filter((data, index: number) => index < 1)
    .forEach((data: any) => {
      header = {
        text: data.value,
        style: ['header', 'bolder'],
        width: 'auto',
        marginBottom: 10,
      } as ContentText;
    });
  return header;
};

const getSubHeaderContent = (content: any[]) => {
  const subHeader: any = [];
  content
    .filter((data, index: number) => index !== 0)
    .forEach((data: any, index: number) => {
      if (data.label) {
        subHeader.push({
          text: data.label,
          style: ['subHeader'],
          width: 'auto',
          marginRight: 5,
        } as ContentText);
      }
      subHeader.push({
        text: data.value,
        style: ['subHeader', data.label ? 'bolder' : ''],
        width: 'auto',
      } as ContentText);
      if (index !== content.length - 2) {
        subHeader.push({
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 10,
              lineWidth: 1,
            },
          ],
          width: 10,
          marginLeft: 5,
        });
      }
    });
  return {
    columns: subHeader,
    marginBottom: 10,
  } as ContentColumns;
};

const getDescriptionContent = (descriptionData: any) => {
  return [
    {
      text: descriptionData.descriptionTitle + ':',
      style: ['header', 'bolder'],
      marginBottom: 6,
    } as ContentText,
    {
      text: descriptionData.descriptionText,
      style: ['subHeader'],
      marginBottom: 10,
    } as ContentText,
    getSolidLineContent(),
  ];
};

const getInsightsContent = (insightsData: any) => {
  const contentStack: Content[] = [];
  const currentYearData = insightsData.insightsContent.currentYearData;
  const previousYearData = insightsData.insightsContent.previousYearData;
  const currentYearContent: Content[] = [];
  if (currentYearData) {
    if (currentYearData.avgOrg) {
      currentYearContent.push({
        text: insightsData.yourOrganizations,
      });
      currentYearContent.push({
        text: ` ${currentYearData.factName ?? 'compensation'} is ${
          currentYearData?.orgAvgSalaryPercentage
        }% (${currentYearData.orgAvgSalaryValue})`,
        style: ['bolder'],
      });
      currentYearContent.push({
        text: ` ${currentYearData.orgAvgSalaryStatus} ${insightsData.insightsDataDescriptionP1}`,
      });
      currentYearContent.push({
        text: ` ${insightsData.insightsTargetData} ${insightsData.insightsDataDescriptionP2}`,
        style: ['bolder'],
      });
    } else {
      currentYearContent.push({
        text: insightsData.insightsNoDataDescriptionP1,
      });
      currentYearContent.push({
        text: ` ${currentYearData.factName ?? 'compensation'}`,
        style: ['bolder'],
      });
      currentYearContent.push({
        text: ' ' + insightsData.insightsNoDataDescriptionP2,
      });
      currentYearContent.push({
        text: ' ' + currentYearData.orgAvgSalaryValue,
        style: ['bolder'],
      });
    }
    const previousYearContent: Content[] = [];
    if (previousYearData) {
      previousYearContent.push(
        {
          columns: [
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0,
                  y1: 0,
                  x2: 500,
                  y2: 0,
                  lineWidth: 0.5,
                  lineColor: PURPLE_LINE_COLOR,
                },
              ],
            },
          ],
          margin: [0, 10],
        },
        {
          columns: [
            {
              width: 12,
              height: 12,
              svg: '<svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.25 1.61536C10.25 1.20114 10.5858 0.865356 11 0.865356H17.0005C17.1994 0.865356 17.3901 0.944382 17.5308 1.08505C17.6715 1.22571 17.7505 1.41649 17.7505 1.61541L17.75 7.61541C17.75 8.02963 17.4142 8.36539 16.9999 8.36536C16.5857 8.36533 16.25 8.02951 16.25 7.6153L16.2503 3.44619L11.6887 8.07906L11.1543 7.55286L11.6887 8.07906C11.5897 8.17961 11.518 8.25246 11.4494 8.31383L10.9492 7.75499L11.4494 8.31383C10.4053 9.24838 8.82616 9.2484 7.78203 8.31385C7.71401 8.25296 7.64321 8.18159 7.54225 8.07905C7.42913 7.96416 7.3968 7.93186 7.37187 7.90955C6.89727 7.48475 6.1794 7.48475 5.7048 7.90955C5.67999 7.93176 5.64781 7.96391 5.5352 8.07827L1.53443 12.1416C1.24381 12.4367 0.768952 12.4404 0.473797 12.1498C0.178642 11.8592 0.174961 11.3843 0.465575 11.0892L4.46635 7.02586C4.47193 7.0202 4.47743 7.01461 4.48286 7.0091C4.57122 6.91932 4.63942 6.85003 4.70441 6.79187L5.20461 7.35071L4.70441 6.79187C5.74853 5.85732 7.32814 5.85732 8.37227 6.79187L7.87207 7.35071L8.37227 6.79187C8.43737 6.85014 8.50574 6.9196 8.59454 7.00981C8.59998 7.01534 8.6055 7.02095 8.6111 7.02664L8.07668 7.55284L8.6111 7.02664C8.72026 7.1375 8.75642 7.17289 8.78242 7.19616L8.28223 7.755L8.78242 7.19616C9.25702 7.62095 9.97441 7.62095 10.449 7.19615C10.4745 7.17339 10.5089 7.13937 10.6199 7.02665L15.2095 2.36536H11C10.5858 2.36536 10.25 2.02957 10.25 1.61536Z" fill="#8338EB"/> </svg>',
            },
            {
              text: [
                {
                  text: 'The',
                },
                {
                  text: ` ${insightsData.insightsMedianAnnualSalary} ${previousYearData?.percentageStatus} is ${previousYearData?.percentage}%`,
                  style: ['bolder'],
                },
                {
                  text: ` ${insightsData.insightsPriorYearDescription} ${previousYearData?.status}.`,
                },
              ],
              width: 'auto',
            },
          ],
        },
      );
    }
    if (currentYearContent?.length) {
      contentStack.push(
        {
          columns: [
            {
              width: 13,
              height: 13,
              svg: '<svg width="15" height="15" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.8917 3.02954C14.9024 3.34571 14.9112 3.68856 14.9108 4.05064C15.2503 12.8215 20.049 12.7854 25.0001 13.2122C15.0556 14.07 14.8591 19.0506 14.8591 23.7822C14.0395 14.0423 8.90859 14.153 4.86523 13.2122C13.98 13.2122 14.9066 7.67071 14.9108 4.05064C14.8981 3.72274 14.8917 3.38254 14.8917 3.02954Z" fill="#8338EB"/> <path d="M7.35314 0C7.3583 0.152314 7.36252 0.317484 7.36232 0.491915C7.5251 4.71727 9.82636 4.69991 12.2007 4.90551C7.43175 5.31874 7.33751 7.71817 7.33751 9.99764C6.94447 5.30541 4.48393 5.35873 2.54492 4.90551C6.91595 4.90551 7.36031 2.23589 7.36232 0.491915C7.35624 0.333951 7.35314 0.170057 7.35314 0Z" fill="#8338EB"/> <path d="M4.80822 14.6177C4.81338 14.77 4.8176 14.9352 4.8174 15.1096C4.98018 19.3349 7.28144 19.3176 9.65574 19.5232C4.88683 19.9364 4.79259 22.3359 4.79259 24.6153C4.39955 19.9231 1.93901 19.9764 0 19.5232C4.37103 19.5232 4.81538 16.8536 4.8174 15.1096C4.81132 14.9516 4.80822 14.7877 4.80822 14.6177Z" fill="#8338EB"/></svg>',
            },
            {
              text: insightsData.insightsTitle,
              width: 'auto',
            },
          ],
          marginBottom: 10,
        },
        {
          columns: [
            {
              width: 12,
              height: 12,
              svg: '<svg width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4322 2.47342C10.1086 2.32933 9.73869 2.32933 9.41505 2.47342C9.30711 2.52148 9.14152 2.64762 8.8624 3.04268C8.58555 3.43453 8.26452 3.98907 7.80279 4.78881L2.95223 13.1902C2.49015 13.9906 2.17025 14.5463 1.96926 14.9822C1.76662 15.4218 1.74014 15.6285 1.75251 15.7462C1.78953 16.0983 1.9744 16.4185 2.26113 16.6268C2.35678 16.6963 2.54876 16.7766 3.03033 16.8208C3.50803 16.8647 4.14874 16.8654 5.07234 16.8654H14.7753C15.6989 16.8654 16.3396 16.8647 16.8172 16.8208C17.2987 16.7766 17.4907 16.6963 17.5863 16.6268C17.8732 16.4184 18.0581 16.0982 18.0951 15.7462C18.1075 15.6284 18.081 15.4217 17.8784 14.9822C17.6775 14.5463 17.3576 13.9905 16.8955 13.1902L12.0458 4.79022C11.5837 3.98987 11.2624 3.43501 10.9854 3.04301C10.7061 2.64782 10.5404 2.52157 10.4322 2.47342ZM8.80495 1.10311C9.51694 0.786107 10.3303 0.786106 11.0423 1.10311C11.5278 1.31927 11.8864 1.71891 12.2104 2.17732C12.5323 2.63289 12.888 3.24904 13.3273 4.00991L18.2112 12.4691C18.6509 13.2307 19.0069 13.8473 19.2406 14.3543C19.4756 14.8641 19.6424 15.3744 19.5869 15.903C19.5054 16.6783 19.0983 17.3824 18.468 17.8403C18.0381 18.1527 17.5129 18.2633 16.9543 18.3145C16.3998 18.3654 15.6898 18.3654 14.8133 18.3654H5.03431C4.1578 18.3654 3.44778 18.3654 2.89325 18.3145C2.33459 18.2633 1.80936 18.1527 1.37945 17.8403C0.74905 17.3823 0.342212 16.6782 0.260729 15.903C0.205175 15.3744 0.372027 14.864 0.607058 14.3542C0.840654 13.8475 1.19643 13.2313 1.63577 12.4704L6.52276 4.00587C6.96095 3.2469 7.31596 2.63198 7.63732 2.17713C7.96104 1.71895 8.31948 1.31925 8.80495 1.10311ZM9.92381 5.86541C10.338 5.86541 10.6738 6.2012 10.6738 6.61541V10.6154C10.6738 11.0296 10.338 11.3654 9.92381 11.3654C9.50959 11.3654 9.17381 11.0296 9.17381 10.6154V6.61541C9.17381 6.2012 9.50959 5.86541 9.92381 5.86541ZM9.124 13.6154C9.124 13.2012 9.45979 12.8654 9.874 12.8654H9.97459C10.3888 12.8654 10.7246 13.2012 10.7246 13.6154V13.7154C10.7246 14.1291 10.3897 14.4646 9.97605 14.4654L9.87547 14.4656C9.6763 14.466 9.48516 14.3872 9.34419 14.2465C9.20322 14.1058 9.124 13.9148 9.124 13.7156V13.6154Z" fill="#8338EB"/> </svg>',
            },
            {
              text: currentYearContent,
              width: 'auto',
            },
          ],
          fontSize: 9,
        },
      );
    }
    if (previousYearContent?.length) {
      contentStack.push(...previousYearContent);
    }
  }
  return {
    layout: 'insightsTableLayout',
    table: {
      widths: '*',
      body: [
        [
          {
            margin: [5, 10],
            columnGap: 8,
            fontSize: 10,
            borderColor: [
              PURPLE_LINE_COLOR,
              PURPLE_LINE_COLOR,
              PURPLE_LINE_COLOR,
              PURPLE_LINE_COLOR,
            ],
            stack: contentStack,
          },
        ],
      ],
    },
    marginBottom: 5,
  } as ContentTable;
};

const getTargetContent = (targetData: any) => {
  return {
    table: {
      widths: 'auto',
      body: [
        [
          {
            text: targetData.label + ':',
            style: ['subHeader', 'bolder'],
            width: 'auto',
            border: [false, false, false, false],
            marginRight: 5,
          },
          {
            text: targetData.value,
            width: 'auto',
            alignment: 'center',
            border: [false, false, false, false],
            fillColor: GREEN_BG_COLOR,
            marginTop: 1,
            style: {
              color: TEXT_WHITE_COLOR,
              fontSize: 8,
            },
          },
        ],
      ],
    },
  } as ContentTable | any;
};

const getChartContent = (chartData: any) => {
  return {
    columns: [
      {
        svg: chartData.lineChartRefSVG,
        width: 250,
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 180,
            lineWidth: 1,
            lineColor: VERTICAL_LINE_COLOR,
          },
        ],
        width: 50,
        margin: [20, 0],
      },
      [
        {
          svg: chartData.barChartRefSVG,
          width: 220,
        },
        {
          text: chartData.fixedVariableNote,
          width: 'auto',
          alignment: 'center',
          border: [false, false, false, false],
          marginTop: -26,
          style: {
            color: '#747373',
            fontSize: 7,
          },
        },
      ],
    ],
    margin: [0, 20],
  } as ContentColumns;
};

const getTableContent = (tableData: any) => {
  const tableHeaderContent: Content[] = [];
  const tableDataContent: Content[] = [];
  tableData.tableHeaderList.forEach((header: string, index: number) => {
    tableHeaderContent.push({
      text: header,
      style: ['tableHeader', 'bolder', index === 1 || index === 2 ? 'tableColumnBg' : ''],
      noWrap: index === 1 || index === 2 || index === 3 ? true : false,
    });
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tableData.tableDetailsList.forEach((row: any[], rowIndex: number) => {
    const dataContent: Content[] = [];
    row.forEach((data: string, index: number) => {
      if (index === 2) {
        if (data && data !== '-') {
          const dataSplit = data.split(' ');
          const textContent: Content[] = [];
          textContent.push({
            text: dataSplit[0],
          });
          if (dataSplit.length > 1) {
            let percentageText = dataSplit[1].trim();
            if (percentageText) {
              percentageText = percentageText.replace(/[^0-9 ]/g, '').trim();
              textContent.push({
                text: ' (' + percentageText + '%)',
                color: Number(percentageText) > 100 ? 'green' : 'red',
              });
            }
          }
          dataContent.push({
            text: textContent,
            style: ['tableContent', 'tableColumnBg'],
          });
        } else {
          dataContent.push({
            text: data,
            style: ['tableContent', 'tableColumnBg'],
          });
        }
      } else {
        dataContent.push({
          text: data,
          style: [
            index === 0 ? 'tableHeader' : 'tableContent',
            index === 0 ? 'bolder' : '',
            index === 1 ? 'tableColumnBg' : '',
          ],
        });
      }
    });
    tableDataContent.push(dataContent);
  });
  return {
    layout: 'reportTableLayout',
    table: {
      headerRows: 1,
      widths: 'auto',
      body: [tableHeaderContent, ...tableDataContent],
    },
  } as ContentTable;
};

const getLevelContent = (level: number) => {
  const levelContent: CanvasElement[] = [];
  for (let index = 0; index < 5; index++) {
    levelContent.push({
      type: 'rect',
      x: index * 8,
      y: index + 1 <= level ? 0 : -1,
      w: index + 1 <= level ? 3 : 5,
      h: index + 1 <= level ? 3 : 5,
      r: index + 1 <= level ? 2 : 4,
      lineWidth: index + 1 <= level ? 3 : 1,
      lineColor: index + 1 <= level ? PURPLE_LINE_COLOR : LINE_COLOR,
    });
  }
  return levelContent;
};

const getProfileContent = (data: SkillsData | BehavioralCompetenciesData) => {
  const profileContent: Content[] = [];
  profileContent.push(
    {
      text: data.name,
      style: ['subHeader'],
    } as ContentText,
    {
      canvas: getLevelContent(data.level),
      marginTop: 5,
    },
  );
  return profileContent;
};

const getSuccessProfileContent = (successProfile: any) => {
  const successProfileContent: Content[] = [];
  const successProfileDetails: SuccessProfileDetails = successProfile.successProfileDetails;
  if (
    successProfileDetails &&
    Object.keys(successProfileDetails).length > 0 &&
    ((successProfileDetails.skills && successProfileDetails.skills.length > 0) ||
      (successProfileDetails.behavioralCompetencies &&
        successProfileDetails.behavioralCompetencies.length > 0))
  ) {
    successProfileContent.push(
      {
        text: successProfile.profileTitle,
        style: ['header', 'bolder'],
        marginBottom: 6,
        pageBreak: 'before',
      } as ContentText,
      getSolidLineContent(),
      {
        text: successProfile.jobSummaryTitle,
        style: ['header', 'bolder'],
        marginBottom: 6,
      } as ContentText,
      {
        text: successProfileDetails.jobSummary || JobPricingReportConstants.NO_DATA_AVAILABLE_MSG,
        style: ['subHeader'],
        marginBottom: 15,
      } as ContentText,
    );
    const skillOddContent: Content[] = [];
    const skillEvenContent: Content[] = [];
    if (successProfileDetails.skills && successProfileDetails.skills.length > 0) {
      successProfileDetails.skills.forEach((skill, index: number) => {
        if ((index + 1) % 2 === 0) {
          skillEvenContent.push({
            columns: getProfileContent(skill),
            marginBottom: 8,
          });
        } else {
          skillOddContent.push({
            columns: getProfileContent(skill),
            marginBottom: 8,
          });
        }
      });
    }
    successProfileContent.push({
      layout: 'successProfileTableLayout',
      table: {
        widths: '*',
        body: [
          [
            {
              text: successProfile.skillsTitle,
              style: ['header', 'bolder'],
              margin: [0, 6],
            } as ContentText,
          ],
          skillOddContent.length > 0 || skillEvenContent.length > 0
            ? [
                {
                  columns: [
                    {
                      stack: skillOddContent,
                    },
                    {
                      stack: skillEvenContent,
                    },
                  ],
                },
              ]
            : [
                {
                  text: JobPricingReportConstants.NO_DATA_AVAILABLE_MSG,
                  style: ['subHeader'],
                } as ContentText,
              ],
        ],
      },
      marginBottom: 15,
    } as ContentTable);
    const behavioralOddContent: Content[] = [];
    const behavioralEvenContent: Content[] = [];
    if (
      successProfileDetails.behavioralCompetencies &&
      successProfileDetails.behavioralCompetencies.length > 0
    ) {
      successProfileDetails.behavioralCompetencies.forEach((behavioral, index: number) => {
        if ((index + 1) % 2 === 0) {
          behavioralEvenContent.push({
            columns: getProfileContent(behavioral),
            marginBottom: 8,
          });
        } else {
          behavioralOddContent.push({
            columns: getProfileContent(behavioral),
            marginBottom: 8,
          });
        }
      });
    }
    successProfileContent.push({
      layout: 'successProfileTableLayout',
      table: {
        widths: '*',
        body: [
          [
            {
              text: successProfile.behavioralCompetenciesTitle,
              style: ['header', 'bolder'],
              margin: [0, 6],
            } as ContentText,
          ],
          behavioralOddContent.length > 0 || behavioralEvenContent.length > 0
            ? [
                {
                  columns: [
                    {
                      stack: behavioralOddContent,
                    },
                    {
                      stack: behavioralEvenContent,
                    },
                  ],
                },
              ]
            : [
                {
                  text: JobPricingReportConstants.NO_DATA_AVAILABLE_MSG,
                  style: ['subHeader'],
                } as ContentText,
              ],
        ],
      },
    } as ContentTable);
  }
  return successProfileContent;
};

const getFooterContent = (footerData: any) => {
  return {
    columns: [
      { width: '*', text: '' },
      {
        layout: 'footerTableLayout',
        width: 'auto',
        table: {
          widths: 'auto',
          body: [
            [
              {
                text: [
                  {
                    text: footerData.publicationMarketLabel + ': ',
                  },
                  {
                    text: footerData.publicationMarketValue,
                  },
                  {
                    text: '  |  ',
                  },
                  {
                    text: footerData.submissionOrgLabel + ': ',
                  },
                  {
                    text: footerData.submissionOrgValue,
                  },
                ],
                fillColor: TABLE_BG_COLOR,
                style: ['tableContent'],
              },
            ],
          ],
        },
      } as ContentTable,
    ],
    marginTop: 25,
    marginRight: 35,
  } as Content;
};

const getPDFDocDefinition = () => {
  return {
    pageMargins: [40, 100, 40, 60],
    content: [],
    defaultStyle: {
      font: 'Lato',
      fontSize: 10,
      color: PRIMARY_TEXT_COLOR,
    },
    styles: {
      bolder: {
        bold: true,
      },
      header: {
        fontSize: 10,
      },
      subHeader: {
        fontSize: 8,
      },
      tableHeader: {
        fontSize: 8,
      },
      tableContent: {
        fontSize: 6,
      },
      tableColumnBg: {
        fillColor: TABLE_BG_COLOR,
      },
    },
  } as TDocumentDefinitions;
};

export const getPDFExportReport = async (pdfDocDetails: any, fileName: string) => {
  const documentPDFDefinition = getPDFDocDefinition();
  await getDataUrlForImageUrl(bgLogoKF).then((dataUrl) => {
    documentPDFDefinition.background = [
      {
        image: dataUrl,
        width: 600,
      },
    ];
  });
  documentPDFDefinition.content = [
    getHeaderContent(pdfDocDetails.headerDetails),
    getSubHeaderContent(pdfDocDetails.headerDetails),
    getSolidLineContent(),
    pdfDocDetails.descriptionDetails ? getDescriptionContent(pdfDocDetails.descriptionDetails) : [],
    getInsightsContent(pdfDocDetails.insightsDetails),
    getDashLineContent(),
    getTargetContent(pdfDocDetails.targetDetails),
    getChartContent(pdfDocDetails.chartDetails),
    getTableContent(pdfDocDetails.tableDetails),
    getSuccessProfileContent(pdfDocDetails.successProfileDetails),
  ];
  documentPDFDefinition.footer = getFooterContent(pdfDocDetails.footerDetails);
  pdfMake.createPdf(documentPDFDefinition).download(fileName);
};
